import React, { useState, useEffect } from "react";
import { Button } from "../components/button/button";
import { Header } from "../components/header/header";
import { Search } from "../components/search/search";
import edit from "../img/edit.svg";
import newDc from "../img/newDc.svg";
import newDcCinza from "../img/newDcCinza.svg";
import person from "../img/person.svg";
import addRackCount from '../img/new_window.svg';
import "../styles/addDc.css";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../auth/axiosInstance";
import { useMsal } from "@azure/msal-react";
import ModalEdit from "../components/modalEdit/modalEdit";
import { Input } from "../components/input/input";
import { useStore } from '../store/useStore'
import Chip from "../components/chip/chip";
import ModalSucesso from "../components/ModalSucesso";
import ModalConfirm from "../components/ModalConfirm/ModalConfirm";
import FooterStatus from "../components/footerStatus/footerStatus";
import Chart from './assets/chart.svg';
import CardDashboard from "../components/CardDashboard/CardDashboard";
import Breadcrumb from "../components/Breadcrumb/Breadcrumb";

function AddDc({ type }) {
  const navigate = useNavigate();
  const [showEdit, setShowEdit] = React.useState(false);
  const [editText, setEditText] = React.useState(false);
  const [values, setValues] = React.useState({});
  const [status, setStatus] = React.useState(false);
  const [content, setContent] = React.useState("");
  const [openModalDelete, setOpenModalDelete] = React.useState(false);
  const [showFeedback, setShowFeedback] = React.useState(false);
  const [typeRequest, setTypeRequest] = React.useState(0);
  const { siteData, fetchData } = useStore()
  const [initialData, setInitialData] = React.useState(siteData)
  const [localVar, setLocalVar] = React.useState(siteData);

  const [showDashboard, setShowDashboard] = useState(false);
  const [siteName, setSiteName] = useState("")

  useEffect(() => {
    setInitialData(siteData)
    setLocalVar(siteData)
  }, [siteData])

  const onChange = (event) => {
    setValues({ ...values, [event.target.name]: event.target.value });
  };

  function newSite(e) {
    e.preventDefault();
    axiosInstance
      .post("sites", values)
      .then((res) => {
        if (res.status === 201) {
          postLog(`Site ${values.site} created`)
          fetchData('sites', 'siteData');
          setValues({});
          setTimeout(() => {
            setShowFeedback(false);

          }, 10000);
          setShowEdit(false);
          setShowFeedback(true);
          setTypeRequest(1);
        }
      })
      .catch((err) => {
        console.log(err);
        setContent("Error on adding data center");
        setStatus(true);
      });
  }

  function putSite(e) {
    e.preventDefault();
    axiosInstance
      .patch(`sites/${values.id}`, {
        site: values.site,
        email: values.email
      })
      .then((res) => {
        if (res.status === 200) {
          postLog(`Site ${values.site} updated`)
          fetchData('sites', 'siteData');
          setValues({});
          setTimeout(() => {
            setShowFeedback(false);

          }, 10000);
          setShowEdit(false);
          setShowFeedback(true);
          setTypeRequest(2);
        }
      })
      .catch((err) => {
        console.log(err);
        setContent("Error on updating data center");
        setStatus(true);
      });
  }

  let items = type !== 'View Only' ? [
    {
      title: "Data Center",
      img: newDcCinza,
      route: '/'
    },
    // {
    //   title: "Add Rack Count",
    //   img: addRackCount,
    //   route: '/select/dc'
    // },
  ] : [
    {
      title: "Data Center",
      img: newDcCinza,
      route: '/'
    },
  ];

  function openModalDel(status) {
    setOpenModalDelete(status);
  }

  const { accounts } = useMsal()

  function postLog(text) {
    axiosInstance.post('logs', {
      email: accounts[0].username,
      name: accounts[0].name,
      action: text
    })
      .catch(err => console.log(err))
  }

  function delSite() {
    axiosInstance
      .delete(`sites/${values.id}`)
      .then((res) => {
        if (res.status === 200) {
          postLog(`Site ${values.site} deleted`)
          fetchData('sites', 'siteData');
          setTimeout(() => {
            setShowFeedback(false);

          }, 10000);
          setShowEdit(false);
          setShowFeedback(true);
          setTypeRequest(3);
          openModalDel(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setContent("Cannot delete this data center, there is one or more datahalls connected to it!");
        setStatus(true);
      });
  }

  return (
    <section className="control-body">
      <Header line>
        <Breadcrumb
          site={false}
          room={false}
          map={false}
          newcount={false}
          diagram={false}
        />
      </Header>
      <div className="search-area">
        <Search
          initialData={initialData}
          set={setLocalVar}
          style={{
            border: "1px solid #0F0742",
            boxShadow: "0 0 0",
            width: type !== 'View Only' ? "75%" : '100%',
          }}
          placeholder="Search Data Center"
        />
        { 
          type == 'View Only' ?
          <></> :
          <Button
            style={{ width: "30%", background: "#0F0742", color: "#fff" }}
            onClick={() => {
              setShowEdit(true);
              return setEditText(false);
            }}
            label={"New Data Center"}
            icon={newDc}
          />
        }
      </div>
      <h1 className="title-totalracks">Total Data Centers ({localVar.length})</h1>
      <section className="table-estructure-dc">
        {localVar.map((value) => {
          return (
            <div className="row-table-estructure">
              <div style={{ width: "13%" }} className="column-table-estructure">
                <h1>Data Center Name</h1>
                <h3>{value.site}</h3>
              </div>
              <div style={{ width: "7%" }} className="column-table-estructure">
                <h1>Total Racks</h1>
                <h3>{value.totalRacks}</h3>
              </div>
              <div style={{ width: "15%" }} className="column-table-estructure">
                <h1>E-Mail</h1>
                <h3>{value.email}</h3>
              </div>
              <div style={{ width: "35%" }} className="column-table-estructure">
                <h1>Room's Added</h1>
                {value.rooms?.length > 0 ? (
                  <div className="list-rooms-table-dc">
                    {value.rooms.map((room, i) => {
                      if (i < 2) {
                        return (
                          <div
                            key={i}
                            style={{ background: '#82D8C050' }}
                            className="style-list-room-table-dc"
                          >
                            {room.room}
                          </div>
                        );
                      } else {
                        return null;
                      }
                    })}
                    <div
                      className="style-list-room-table-dc"
                      style={
                        value.rooms.length > 3
                          ? {
                            display: "flex",
                            background: '#82D8C050',
                          }
                          : { display: "none" }
                      }
                    >
                      + {value.rooms.length - 2}
                    </div>
                  </div>
                ) : (
                  <h3>No Data</h3>
                )}
              </div>

              {/* BTN CARD DASHBOARD */}
              <div className="content-view-room btn-dh-dashboard"
                onClick={() => (setShowDashboard(true), setSiteName(value.site))}
              >
                <img src={Chart} alt="view dashboard"/>
              </div>

              <div className="content-view-room">
                {type !== 'View Only' && <img
                  onClick={() => {
                    setEditText(true);
                    setShowEdit(true);
                    return setValues(value);
                  }}
                  src={edit}
                  alt="edit"
                />}
                <Button
                  onClick={() =>
                    navigate(`/room/${value.site}/${value.id}`)
                  }
                  style={{ width: 186 }}
                  label={"View DH"}
                />
              </div>
            </div>
          );
        })}
      </section>





      
      <ModalEdit
        show={showEdit}
        close={() => { setShowEdit(false); return setValues({}) }}
        hidenDelete={false}
        deletar={() => {
          openModalDel(true);
        }}
        label={`${editText
          ? "Insert the information below to edit a data center"
          : "Insert the information below to register a new data center"
          }`}
        title={`${editText ? "Edit Data Center" : "New Data Center"}`}
        labelButton={`${editText ? "Edit" : "Add"}`}
        iconButton={newDc}
        function={editText ? (e) => putSite(e) : (e) => newSite(e)}
        styleButton={editText ? !editText : Object.keys(values).length < 2
          ? { cursor: "not-allowed", backgroundColor: '#ccc' }
          : {}
        }
        disabled={editText ? !editText : Object.keys(values).length < 2}>
        <Input
          placeholder={"Data Center Name"}
          onChange={onChange}
          required={!editText}
          value={Object.keys(values).length > 0 ? values.site : ''}
          name="site"
          title="Data Center Name"
        />
        <Input
          placeholder="email@scaladatacenters.com"
          type="email"
          onChange={onChange}
          name="email"
          value={Object.keys(values).length > 0 ? values.email : ''}
          required={!editText}
          title="E-Mail"
        />
      </ModalEdit>

      <ModalSucesso
        status={status}
        content={content}
        ok={() => (setStatus(false), openModalDel(false))}
      />

      <div style={openModalDelete ? { display: "flex" } : { display: "none" }}>
        <ModalConfirm
          yes={() => delSite()}
          no={() => openModalDel(false)}
          content={"Are you sure you want to delete this data center?"}
        />
      </div>
      <FooterStatus
        show={showFeedback}
        showButton={false}
        cancel={() => setShowFeedback(false)}
        text={
          typeRequest === 1
            ? `Rack Count successfully added, you can see it in the respective area.`
            : typeRequest === 2
              ? `Data Center successfully updated, you can see it in the respective area.`
              : `Data Center successfully deleted, you can see it in the respective area.`
        }

      />

      {
        showDashboard ?
          <CardDashboard
            close={() => (setShowDashboard(false), setSiteName(''))}
            siteName={siteName}
          />
        :
          <></>
      }

    </section >
  );
}

export default AddDc;
